<template>
  <div>    
    <div class="flex flex-col antialiased text-xs text-pastel-black h-full">
      
      <l-header />
      <l-toolbar>
        <l-menu />
      </l-toolbar>
      <div class="flex-grow">
        <router-view />
      </div>
    </div>
    <vue-toastify :withBackdrop="true" position="top-center" :lightTheme="true" style="z-index:999"></vue-toastify>
  </div>
</template>

<script>
import LHeader from "@/components/LHeader";
import LToolbar from "@/components/LToolbar";
import LMenu from "@/components/LMenu";

export default {
  name: "App",
  components: {
    LMenu,
    LToolbar,
    LHeader
  }
};
</script>

<style lang="postcss">
@import "../../assets/styles/tailwind.postcss";
@import "~pretty-checkbox/dist/pretty-checkbox.min.css";


/*override checkbox color*/
.pretty input:checked ~ .state.p-success label:after,
.pretty.p-toggle .state.p-success label:after {
  @apply bg-pastel-green-500 !important;
}

html,
body {
  height: 100%;
}

body {
  @apply h-full bg-gray-200 subpixel-antialiased antialiased tracking-wide;
  font-family: "Rubik", arial;
  margin: 0;
}

input:focus,
select:focus,
textarea:focus,
button:focus {
  outline: none;
}

.btn-disabled {
  @apply bg-bluegray-300;
  pointer-events: none;
}
</style>
